import devis from "../../images/devis.png";
import Features from "../../components/Features/Features";
import logo from "../../images/logo/logo.jpg";
import travaux from "../../images/travaux.jpg";
import { Link } from "react-router-dom";

function MainPage() {
  return (
    <>
      <section className="solution ">
        <div>
          <h1>Une Solution Pour Vos Installations.</h1>
          <p>
            Bienvenue chez Lemaire plomberie des weppes un partenaire de confiance vous accompagnant pour vos installations de plomberie,
            chauffages, cuisines, salle de bain et second oeuvres. Avec notre expérience nous vous offrons un service d'une qualité qui
            dépasse vos attentes.
          </p>
          <div className="button-group">
            <Link to={"/FAQ"} className="button">
              FAQ
            </Link>
            <Link to={"/contact"} className="button-two">
              Contact
            </Link>
          </div>
        </div>
        <img src={logo} alt="logo" />
      </section>
      <section className="solution ">
        <div>
          <h1>15 Ans d'Excellence.</h1>
          <p>
            Avec 15 ans d'expérience dans le domaine du bâtiment et de la rénovation, nous sommes votre partenaire de confiance pour des
            travaux réalisés dans les règles de l'art. Nous sommes spécialisés dans l'installation de cuisines et de salle de bain ainsi,
            que l'entretien et la réparation de tous types de poêles. En outre, nous offrons des services complets de tubage et de ramonage
            pour assurer le bon fonctionnement de vos installations. Basés dans la métropole lilloise, nous intervenons dans toute la région
            et ses alentours, offrant des services rapides et fiables. Faites confiance à notre expertise pour vos projets de rénovation,
            d'installation et d'entretien. Contactez-nous dès aujourd'hui pour un devis personnalisé ou pour en savoir plus sur nos
            services.
          </p>
          <div className="button-group">
            <Link to={"/FAQ"} className="button">
              FAQ
            </Link>
            <Link to={"/galerie"} className="button-three">
              Galerie
            </Link>
            <Link to={"/contact"} className="button-two">
              Contact
            </Link>
          </div>
        </div>
        <img src={travaux} alt="logo" />
      </section>
      <section>
        <h2>Nos experts vous offre un vrai accompagnement.</h2>
        <div className="features-grid">
          <Features
            title={"Des chauffages efficace pour un confort optimal"}
            text={"Nous vous offront le meilleur en terme d'équipement et d'installation."}
          />
          <Features
            title={"Une disponibilité 24/7 en cas d'urgence"}
            text={"Nous vous offront une réponse rapide pour les réparations d'urgence pour vos systémes"}
          />
          <Features
            title={"Un service de rénovation et de maintenance offerte par nos experts"}
            text={"Garder votre systeme de plomberie et de chauffage au top de leurs formes grace à nos experts"}
          />
        </div>
      </section>
      <section className="solution ">
        <div>
          <h1>Demander un Devis Gratuit Aujourd'hui.</h1>
          <p>N'hésitez pas à nous contacter pour discuter de vos besoins et pour obtenir un devis gratuit.</p>
          <div className="button-group">
            <Link to={"/contact"} className="button">
              Contact
            </Link>
            <Link to={"/FAQ"} className="button-two">
              FAQ
            </Link>
          </div>
        </div>
        <img src={devis} alt="devis" />
      </section>
    </>
  );
}

export default MainPage;
